
import React from 'react';
import { Job } from './types';
import { JobCard } from './JobCard';

interface JobGridViewProps {
  jobs: Job[];
}

export const JobGridView: React.FC<JobGridViewProps> = ({ jobs }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {jobs.map((job) => (
        <JobCard key={job.id} job={job} />
      ))}
    </div>
  );
};
